import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'collectionAccount',
  namespaced: true,
  actions: {
    async updateAccount({ rootState }, account) {
      const { data } = await defaultApi.putCollectionAccounts(rootState.auth.info.uuid, account)
      return data
    },
  },
}
